import { useContext } from 'react';

import { Box, Typography, useMediaQuery } from '@mui/material';

import BiwengerScoreComponent from '@/components/biwenger/biwenger-score';
import CustomImageComponent from '@/components/shared/custom/custom-image';
import ApercibidosStatusIcon from '@/components/shared/icons/apercibidos-status-icon';
import { REDUCERS } from '@/constants/reducers';
import { Context } from '@/context';
import { FANTASY_MODE } from '@/helpers/biwenger-helper';
import { getCountryImage, getMasterPhotoById } from '@/helpers/images-helper';
import { getPlayerIconWhenIsNotOk } from '@/helpers/players-helper';
import { toPriceInEuros } from '@/helpers/prices-helper';

import EquipoAddPlayerBox from './EquipoAddPlayerBox';

const EquipoPlayerLineupBiwengerMode = ({ player, subMode, onClick, customSize, banquillo = false }) => {
    const { dispatch } = useContext(Context);
    const id = player?.information?.id ?? 0;
    const marketValue = player?.biwengerPlayer?.price ?? player?.biwengerPlayer?.marketValue ?? 0;
    const subida = player?.biwengerPlayer?.priceIncrement ?? player?.biwengerPlayer?.subida ?? 0;

    const color = '#fff';

    const isMobile = useMediaQuery('(max-width:576px)');
    const cardHeight = isMobile ? 120 : 130;

    let size = isMobile ? 70 : 80;

    if (customSize) {
        size = customSize;
    }

    const getBiwengerPlayer = () => {
        switch (subMode) {
            case FANTASY_MODE.SOFASCORE:
                return player?.biwengerSofascore;
            case FANTASY_MODE.STATS:
                return player?.biwengerStats;
            case FANTASY_MODE.AVERAGE:
                return player?.biwengerAverage;
            case FANTASY_MODE.SOCIAL:
                return player?.biwengerSocial;
            case FANTASY_MODE.DIARIO_AS:
            default:
                return player?.biwengerAs;
        }
    };

    const biwengerPlayer = getBiwengerPlayer();

    const racha = biwengerPlayer?.fitness?.slice(-3) ?? biwengerPlayer?.fitness;
    const points = biwengerPlayer?.points ?? '-';
    const media = biwengerPlayer?.information?.averagePoints ?? biwengerPlayer?.averagePoints ?? '-';

    const handleClick = (playerId) => {
        if (onClick) {
            onClick();
        } else if (playerId > 0) {
            dispatch({ type: REDUCERS.SHOW_MASTER_ACCIONES_PLAYER_ID, payload: playerId });
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                height: banquillo ? 'auto' : cardHeight,
                width: size,
            }}
        >
            <Box sx={{ position: 'relative', width: size, height: size }} onClick={() => handleClick(id)}>
                <CustomImageComponent
                    src={getMasterPhotoById(id)}
                    alt="jugador"
                    width={size}
                    height={size}
                    onClick={() => handleClick()}
                />

                {player?.generalStatus?.isApercibido && (
                    <ApercibidosStatusIcon
                        iconWidth={15}
                        iconHeight={15}
                        styles={{ position: 'absolute', bottom: 0, left: 0 }}
                    />
                )}

                <Box style={{ position: 'absolute', bottom: 0, right: '5px' }}>
                    {getPlayerIconWhenIsNotOk(
                        player?.generalStatus?.status,
                        player?.generalStatus?.statusLevel
                    )}
                </Box>

                {player?.convocatoriaSeleccion?.isConvocado && (
                    <Box style={{ position: 'absolute', top: 0, right: 0 }}>
                        <CustomImageComponent
                            src={getCountryImage(player?.convocatoriaSeleccion?.countryCode, 30)}
                            width={20}
                            height={20}
                            alt="selección"
                            style={{ borderRadius: '50%' }}
                        />
                    </Box>
                )}
            </Box>
            {id === 0 && <EquipoAddPlayerBox />}

            {id > 0 && (
                <Box display={'flex'} justifyContent={'center'} gap={'4px'} mt={0.5}>
                    {racha?.map((score, index) => (
                        <BiwengerScoreComponent
                            score={score}
                            key={index}
                            width={15}
                            height={15}
                            fontSize="10px"
                            size={14}
                        />
                    ))}
                    {!racha && <Box sx={{ height: '16px' }}> - </Box>}
                </Box>
            )}

            <Typography
                sx={{ textAlign: 'center', color: color, fontSize: '12px' }}
                onClick={() => handleClick(id)}
            >
                {marketValue > 0 ? toPriceInEuros(marketValue) : id > 0 ? '-' : ''}
            </Typography>

            <Typography
                sx={{
                    textAlign: 'center',
                    color: '#fff',
                    fontSize: '10px',
                    background: subida > 0 ? '#338d42' : '#d65555',
                    width: '60px',
                    borderRadius: '4px',
                }}
                onClick={() => handleClick(id)}
            >
                {subida !== 0 ? toPriceInEuros(subida) : id > 0 ? '-' : ''}
            </Typography>

            {id > 0 && (
                <Box display={'flex'} justifyContent={'center'} gap={'4px'}>
                    <Typography fontSize={11} color={color}>
                        P: {points}
                    </Typography>
                    <Typography fontSize={11} color={color}>
                        M: {media}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default EquipoPlayerLineupBiwengerMode;
